let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cbHUA")).then(() => parcelRequire('91Xd7'));